import { useAccount } from '../../context/AccountContext';
import { useProduct } from '../../context/ProductContext';
import { useTinycmsSites } from './sites';

/**
 * What the selected site has beyond tinycms itself:
 *   Atomize  the atomizer product. "held" also covers switched off (it can be
 *            switched back on); Atomize isn't launched, so nobody else gets it.
 *   Reach    the reach product (comes with Pro).
 * isOwner: the person is an admin of this site (they can change its plan).
 */
export function useAddons() {
  const { selectedAccount } = useAccount();
  const { entitled } = useProduct();
  const { sites } = useTinycmsSites();
  const products = selectedAccount?.products;
  const atomizeOn =
    products == null
      ? entitled.includes('atomizer')
      : products.some((p) => p.product === 'atomizer' && p.status === 'active');
  const atomizeHeld = products == null ? atomizeOn : products.some((p) => p.product === 'atomizer');
  const here = sites.find((s) => s.accountId === selectedAccount?.id);
  return {
    atomizeOn,
    atomizeHeld,
    reachOn: entitled.includes('reach'),
    isOwner: here ? here.role === 'admin' : true,
    ownerEmail: here?.ownerEmail || null,
  };
}
